import type { IGuideWeekDaySlug } from 'types/guides/guideshop';

interface IStates {
  [key: string]: string;
}

export interface IConstants {
  STATES: IStates;
  DAYS_OF_WEEK: IGuideWeekDaySlug[];
  ADDRESS_DEFAULT: string;
  RADIUS_DEFAULT: string;
  QUANTITY_DEFAULT: number;
}

export const DYNAMIC_GUIDE_SECTION_KEYS = ['section_guide_search', 'section_guide_all_stores_list'];

const constants: IConstants = {
  STATES: {
    AC: 'Acre',
    AL: 'Alagoas',
    AM: 'Amazonas',
    AP: 'Amapá',
    BA: 'Bahia',
    CE: 'Ceará',
    DF: 'Distrito Federal',
    ES: 'Espírito Santo',
    GO: 'Goiás',
    MA: 'Maranhão',
    MG: 'Minas Gerais',
    MS: 'Mato Grosso do Sul',
    MT: 'Mato Grosso',
    PA: 'Pará',
    PB: 'Paraíba',
    PE: 'Pernambuco',
    PI: 'Piauí',
    PR: 'Paraná',
    RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte',
    RO: 'Rondônia',
    RR: 'Roraima',
    RS: 'Rio Grande do Sul',
    SC: 'Santa Catarina',
    SE: 'Sergipe',
    SP: 'São Paulo',
    TO: 'Tocantins',
  },
  DAYS_OF_WEEK: [
    'domingo',
    'segunda-feira',
    'terca-feira',
    'quarta-feira',
    'quinta-feira',
    'sexta-feira',
    'sabado',
  ] as IGuideWeekDaySlug[],
  ADDRESS_DEFAULT: 'São Paulo',
  RADIUS_DEFAULT: '30000',
  QUANTITY_DEFAULT: 4,
};

export default constants;
